import EventPage from "~/components/events";
import Metadata from "~/components/metadata";

export default function Events() {
  return (
    <>
      <Metadata
        pageTitle="Advante Events"
        title="Exciting Events"
        description="We help individuals and teams achieve their full potential through our events."
        canonical="https://advante.co/events"
      />
      <EventPage />
    </>
  );
}
